import React from "react";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Sandra Z.",
    place: "Perpignan",
    rating: 5,
    text: "Tout simplement merci, rapide efficace et d'une extrême gentillesse. Je recommande +++++.",
  },
  {
    name: "Louis Lecœur",
    place: "Perpignan",
    rating: 5,
    text: "Personnel très sérieux, répond à toute heure et se déplace très rapidement. Service au top, je vous le conseille fortement.",
  },
  {
    name: "Alexandra Ramos",
    place: "Perpignan",
    rating: 5,
    text: "Pour être au top, il est plus que sérieux. C'est une crème, ce garçon — il est ponctuel et très à l'écoute du client. Je le recommande, c'est le remorqueur le plus sérieux de Perpignan.",
  },
  {
    name: "Julie",
    place: "Perpignan",
    rating: 5,
    text: "Très professionnel et rapide. Nous a même ramenés chez nous ! Je vous le recommande fortement.",
  },
];

export const Testimonials = () => {
  return (
    <section id="avis" className="relative py-24 sm:py-32 bg-[#0A0A0A]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">
              — Avis clients
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
              Ils m'ont fait<br />
              <span className="text-[#FFD600]">confiance.</span>
            </h2>
          </div>

          <div className="flex items-center gap-4 bg-[#171717] border border-[#262626] rounded-lg px-6 py-4">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-[#FFD600] text-[#FFD600]" />
              ))}
            </div>
            <div>
              <div className="font-display text-2xl text-white">5.0 / 5</div>
              <div className="text-neutral-400 text-xs uppercase tracking-wider">Sur Google</div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`review-${i}`}
              className="relative bg-[#171717] border border-[#262626] rounded-lg p-7 hover:border-[#FFD600]/40 transition-colors"
            >
              <Quote className="absolute top-5 right-5 w-10 h-10 text-[#FFD600]/15" />
              <div className="flex mb-4">
                {[...Array(r.rating)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#FFD600] text-[#FFD600]" />
                ))}
              </div>
              <p className="text-neutral-300 leading-relaxed mb-5 text-base">"{r.text}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-white/5">
                <div className="h-10 w-10 rounded-full bg-[#FFD600] text-[#0A0A0A] font-display flex items-center justify-center text-lg">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="text-white font-semibold text-sm">{r.name}</div>
                  <div className="text-neutral-500 text-xs uppercase tracking-wider">{r.place}</div>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-8 text-neutral-500 text-xs text-center">
          Avis collectés sur la fiche Google Business "MK Remorquage" — clients réels.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
